/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createGlobalStyle } from 'styled-components';
import { checkValue } from '../helper';
import { convertObjectToCSS, themeToken } from '../cpds/utils/cpds-utils';

/**
 * IMPORTANT Note:
 * When using 'npm run createNewComponent', there's no need to manually import the CSS file here.
 * The styling for the component will be automatically imported from the component itself.
 * Please refer v2/v2-text-module/index.txt
 */

// Common Css Style Import
import(/* webpackChunkName: "page-loader-styles" */ 'src/components/common/modules/loader/styles/page-loader.css');
import(/* webpackChunkName: "quiz-page-styles" */ 'src/components/common/modules/v1/quiz-module/styles/quiz-page.css');
import(
  /* webpackChunkName: "quiz-module-styles" */ 'src/components/common/modules/v1/quiz-module/styles/quiz-module.css'
);
import(
  /* webpackChunkName: "featuredMedia-styles" */ 'src/components/common/modules/v1/featured-media/styles/featuredMedia.css'
);
import(
  /* webpackChunkName: "module-color-bar-styles" */ 'src/components/common/modules/module-color-bar/styles/module-color-bar.css'
);
import(
  /* webpackChunkName: "copyright-with-gradient-styles" */ 'src/components/common/modules/copyright-with-gradient/styles/copyright-with-gradient.css'
);
import(
  /* webpackChunkName: "image-card-v2-styles" */ 'src/components/common/modules/image-card/image-card-v2/styles/image-card-v2.css'
);
import(
  /* webpackChunkName: "v1-entryFormStyle-styles" */ 'src/components/common/modules/v1/entry-form/styles/entry-form.css'
);

// Css Style V2 Import
import(
  /* webpackChunkName: "v2-shared-styles" */ 'src/components/common/modules/v2/shared/module-content/styles/module-content.css'
);
import(
  /* webpackChunkName: "v2-shared-styles" */ 'src/components/common/modules/v2/shared/module-title/styles/module-title.css'
);
import(
  /* webpackChunkName: "v2-shared-styles" */ 'src/components/common/modules/v2/shared/slick-arrows/styles/slick-arrows.css'
);
import(
  /* webpackChunkName: "v2-shared-styles" */ 'src/components/common/modules/v2/shared/tags/styles/tags.css'
);
import(
  /* webpackChunkName: "v2-shared-styles" */ 'src/components/common/modules/v2/shared/hotel-partner-card/styles/hotel-partner-card.css'
);
// Css Style Import
import(/* webpackChunkName: "v1-media-carousel-module-styles" */ 'src/components/common/modules/v1/media-carousel-module/styles/media-carousel-module.css');
import(/* webpackChunkName: "text-balancer-module-styles" */ 'src/components/common/ui/text-balancer/styles/text-balancer.css');

// Css SearchWizard
import(/* webpackChunkName: "search-wizard-module-styles" */ 'src/components/common/SearchWizard/shareduiwizard/Lodging/vrbo/styles/vrbo-hotel-widget.css');
import(/* webpackChunkName: "search-wizard-module-styles" */ 'src/components/common/SearchWizard/shareduiwizard/Lodging/hotels/styles/hotels-hotel-widget.css');

const StaticStyles = (content) => {  
  return ``;
};

const StaticCpLiteStyles = (content, theme = undefined ) => { 
  if(checkValue(theme)){
    const cpdstoken = theme?.themeColorMode === 'light' ? theme?.light : theme?.dark;
    const cpdsTheme = `${theme?.themeType}-${theme?.brand}-${theme?.themeColorMode}`;    
    const brandCss = convertObjectToCSS(cpdstoken.typography);
      return `[data-cpds-theme="${cpdsTheme}"] {
        ${brandCss}
      }
      
      [data-cpds-theme="${cpdsTheme}"] .v3-booking-widget .v3-global-search-wizard-wrapper h3, .v3-flight-stop-over-component .v3-global-search-wizard-wrapper h3 {
          font-size: unset;
          line-height: unset;
          font-family: unset;
          font-weight: unset;
          letter-spacing: unset;
      }
      
      [data-cpds-theme="${cpdsTheme}"] .v3-booking-widget .v3-global-search-wizard-wrapper p, .v3-flight-stop-over-component .v3-global-search-wizard-wrapper p {
          font-size: unset;
          line-height: unset;
          font-family: unset;
          font-weight: unset;
          letter-spacing: unset;
      }
      
    `;
  }else{
    return ``;
  }
};

/// Special styles for partner
/// This is a special case for partner
/// This will be removed with the V3 release
const PartnerHomeStaticStyles = () => { 
  return `
  /* Global Hero */

          .v2-global-hero-section .hero-text-component.text-centered h1.hero-title{
              line-height: 102px !important;
              letter-spacing: -0.92px !important;
              font-weight: 600 !important;

              @media (max-width: 575px) {
                line-height: 54px !important;
                letter-spacing: -0.52px !important;
                
              }
          }

          .v2-global-hero-section .hero-text-component.text-centered p.hero-sub-title{
              font-size: 28px !important;
              font-weight: 600 !important;
              line-height: 36px !important;

              @media (max-width: 575px) {
                font-size: 22px !important;
                line-height: 30px !important;
                
              }
          }

          .v2-global-hero-section .hero-text-component.text-centered .hero-sub-title{
            max-width:75% !important;

            @media (max-width: 575px) {
              max-width:100% !important;
              
            }
          }

/* Content Module */  

          .v2-content .v2-content-module h2.cms-typo {
              font-weight: 600 !important;
          }

          .v2-content-module-section .v2-content .v2-content-module p.cms-typo {

              @media only screen and (max-width: 575px) {
               font-size: 24px; 
               line-height: 38px; 
              }
          }


/* Content Tile */       
          .v2-content-tile__slider .slick-slider .slick-slide .description-title {
              @media (max-width: 575px) {
                font-size: 24px !important;
                line-height: 28px !important;
                font-weight: 600 !important;
              }
          }         

 /* Product Integration */
          .v2-product-integration .v2-product-integration-panel-info h2.cms-typo {
             font-weight: 600 !important;
          }

          .v2-product-integration .v2-product-integration-panel-info p.cms-typo {
              font-size: 18px !important;
              font-weight: 400 !important;
              line-height: 27px !important;
            
          }

          .v2-product-integration .v2-product-integration-panel-info {
            @media (max-width: 575px) { 
              padding-left: 0px !important; 
              padding-right: 0px !important;
            }
        }

/* Quote module */
          .quote-overlay-module.quote-module-centered h2.cms-typo {
              line-height: 78px !important;
              letter-spacing: -1.92px !important;
              font-weight: 600 !important;

              @media only screen and (max-width: 575px) {
              
                 line-height: 48px !important;
                 letter-spacing: 0px !important;
                 width: 60% !important;
              }
          }

/* Featured Hotel Deals */
          .v2-featured-hotel-deals--inner-container .title-container.without-signup-space {
              display: flex;
              max-width: 100%;
              justify-content: center;
              flex-direction: column;
          }

          
          .v2-featured-hotel-deals--inner-container .main-title {
              font-size: 42px !important;
              font-weight: 600 !important;
              line-height: 44px !important;
          }

          .v2-featured-hotel-deals--inner-container .summery {
              max-width: 872px;
              align-self: center;
              width: 62%;

              @media (max-width: 575px) { 
                width: 100%;
              }
          } 

         
          .v2-product-integration .v2-product-integration-panel-info p.cms-typo {
              @media only screen and (max-width: 769px) {
                margin: 0 !important;
              }
          }


/* Search Wizard */
          .v2-container.v2-booking-widget .vrbo-booking-section{

              padding-top: 0px !important;

              .vrbo-heading-wrapper{
                  padding-top: 0px !important;
              }
          }


        `;
};
const PartnerArticleStaticStyles = () => {  
  return `
  /* Global Hero */

          .v2-global-hero-section .hero-text-component.text-centered h1.hero-title{
              line-height: 102px !important;
              letter-spacing: -0.92px !important;
              font-weight: 600 !important;

              @media (max-width: 575px) {
                line-height: 54px !important;
                letter-spacing: -0.52px !important;
                
              }
          }

          .v2-global-hero-section .hero-text-component.text-centered p.hero-sub-title{
              font-size: 28px !important;
              font-weight: 600;
              line-height: 36px !important;

              @media (max-width: 575px) {
                font-size: 22px !important;
                line-height: 30px !important;
                
              }
          }

          .v2-global-hero-section .hero-text-component.text-centered .hero-sub-title{
            max-width:75% !important;

            @media (max-width: 575px) {
              max-width:100% !important;
              
            }
          }

/* Content Module */    

          .v2-content .v2-content-module h2.cms-typo {
              font-weight: 600 !important;
             
          }

          .v2-content-module-section .v2-content .v2-content-module p.cms-typo {

              font-size: 18px !important;
              line-height: 27px !important;

              @media only screen and (max-width: 575px) {
               font-size: 18px !important;
               line-height: 27px !important;
              }
          }

/* v2-video-module */
          .v2-video-module {
              padding-left: 0px !important;
              padding-right: 0px !important;
              padding-bottom: 30px !important;
          }

          .v2-video-module.video-section .video-testimonial {
              max-width: 100% !important;
          }


          .spotlight .main-article h2.cms-typo{
               font-weight: 600 !important;

          }

/* double image card */
            .double-image-panel-wrapper {
                @media only screen and (max-width: 575px) {
                    display: flex;
                    width: 100%;
                    flex-direction: column !important;
                    margin: 0 auto;
                    position: relative;
                }
            }

            .double-image-content-1 {
              @media (max-width: 575px) {
                margin-left: 0 !important;
              }
            }

            .double-image-panel-container.module-spacing {

                @media only screen and (max-width: 575px) {
                  padding-top: 35px !important; 
                }
            }

           
            .double-image-content-image {
                @media only screen and (max-width: 575px) {
                   padding: 0px !important; 
                }
            }

          .double-image-content-caption-container {
              padding: 0 !important;
              p.cms-typo {
                font-size: 16px !important;

                @media only screen and (max-width: 575px) {
                   font-size: 18px !important;
                }
              }
          }

/* Quote module */
          .quote .quote-overlay-module {
              max-width: 76%;
               @media only screen and (max-width: 575px) {
                 max-width: 100%;
              }
          }

         
         .quote-overlay-module.spotlight-component-wrapper {
              @media only screen and (max-width: 575px) {
                  padding-left: 28px !important;
                  padding-right: 18px !important;
              } 
          }

          .quote-overlay-module.quote-module-left h2.cms-typo {
              line-height: 78px !important;
              @media only screen and (max-width: 575px) {
                  font-size: 40px !important;
                  line-height: 50px !important;
                  letter-spacing: -0.4px;
              }
          }

          .quote-overlay-module .quote-wrapper p.cms-typo.quote-author {
              font-size: 16px !important;
          }

/* Product Integration */
          .v2-product-integration .v2-product-integration-panel-info h2.cms-typo {
             font-weight: 600 !important;
             @media (max-width: 575px) { 
              width:220px !important;
             }
          }

          .v2-product-integration .v2-product-integration-panel-info p.cms-typo {
              font-size: 18px !important;
              font-weight: 400 !important;
              line-height: 27px !important;
            
          }

          .v2-product-integration .v2-product-integration-panel-info {
            @media (max-width: 575px) { 
              padding-left: 0px !important; 
              padding-right: 0px !important;
            }
          }

          .v2-product-integration .v2-product-integration-panel-title h2.cms-typo {
              font-size: 36px !important;
              text-decoration: underline;
              text-underline-offset: 25px;
              padding-bottom: 35px;

              @media only screen and (max-width: 575px) {
                text-underline-offset: 10px;
                padding-bottom: 20px !important;
                Line height: 50px !important;
              }
          }

          .v2-product-integration .v2-product-integration-panel-title .subhead-wrapper h3{
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              font-size: 42px !important;
              font-weight: 600 !important;
              line-height: 44px !important;
              svg{
                visibility: hidden !important;
                width:0px !important;
              }
          
          }

/* two-column-tile */ 
        .two-column-tile-outer-wrapper .two-column-tile-wrapper h2.cms-typo.two-column-tile-headline{
              line-height: 44px !important;
        }

        .two-column-tile-outer-wrapper .two-column-tile-wrapper .two-column-tile-title-wrapper{
              display: flex;
              max-width: 100%;
              flex-direction: column;
        }

        .two-column-tile-outer-wrapper .two-column-tile-wrapper h3.cms-typo.two-column-tile-subheadline{
              font-size: 18px !important;
              font-weight: 400 !important;
              line-height: 27px !important;
              align-self: center;
              width: 45%;
              @media (max-width: 575px) { 
                width: 90%;
                margin-bottom: 0px !important;
              }
        }

        .two-column-tile-content .two-column-tile-text-content {
            text-align: center;
            display: flex;
            justify-content: center;
            width: 100%;
            @media (max-width: 575px) { 
                text-align: start;
              
            }
            h3.cms-typo.two-column-tile-sub-headline{
              font-size: 24px !important;
              font-weight: 600 !important;
              line-height: 32.4px !important;
              letter-spacing: -0.72px;
              width: 100%;
              padding: 0 20px;
 
              @media (max-width: 769px) {
                padding: 0 5px;
              }
 
              @media (max-width: 575px) {
                padding: 0;
                width: 100%;
                line-height: 28px !important;
 
                br {
                  display: none;
                }
              }
            }
        }    
/* Featured Hotel Deals */
          .v2-featured-hotel-deals--inner-container .title-container.without-signup-space {
              display: flex;
              max-width: 100%;
              justify-content: center;
              flex-direction: column;
          }

          
          .v2-featured-hotel-deals--inner-container .main-title {
              font-size: 42px !important;
              font-weight: 600 !important;
              line-height: 44px !important;
          }

          .v2-featured-hotel-deals--inner-container .summery {
              max-width: 872px;
              align-self: center;
              width: 62%;

              @media (max-width: 575px) { 
                width: 100%;
              }
          } 
/* Search Wizard */
          .v2-container.v2-booking-widget .vrbo-booking-section{

              padding-top: 0px !important;

              .vrbo-heading-wrapper{
                  padding-top: 0px !important;
              }
          }


         

        `;
};

const StaticStylesForSpotlightOwn = (data) => {
  if (!checkValue(data.bodyFont)) return '';
  else if (data.bodyFont === 'Reckless XPD Book / Centra No2')
  return `
  font-family: "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      body{
        font-family: "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
      .override-heading-font-family{
          font-family: "Reckless XPD Book", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }    
  `;
};
const StaticStylesForSpotlightQuizPage = () => {
  return '';
};

const GlobalStyleLoader = createGlobalStyle`${(props) => props.data}`;

export { GlobalStyleLoader, StaticStyles, StaticCpLiteStyles, StaticStylesForSpotlightOwn, StaticStylesForSpotlightQuizPage, PartnerHomeStaticStyles, PartnerArticleStaticStyles };
